<style>
  .lightbox-overlay {
    position: fixed;
    inset: 0;
    background: rgba(5, 5, 5, 0.95);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 700ms cubic-bezier(0.25, 1, 0.5, 1);
  }

  .lightbox-overlay.visible {
    opacity: 1;
  }

  .lightbox-content {
    max-width: 90vw;
    max-height: 90vh;
    position: relative;
  }

  .lightbox-content img,
  .lightbox-content video {
    max-width: 100%;
    max-height: 90vh;
    width: auto;
    height: auto;
    display: block;
  }

  .nav-button {
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: var(--ink);
    font-size: 3rem;
    cursor: pointer;
    padding: 2rem;
    mix-blend-mode: difference;
    transition: opacity 300ms;
    font-family: "Inter", sans-serif;
    font-weight: 300;
  }

  .nav-button:hover {
    opacity: 0.7;
  }

  .nav-button.prev {
    left: 0;
  }

  .nav-button.next {
    right: 0;
  }

  .counter {
    position: fixed;
    bottom: 2rem;
    left: 50%;
    transform: translateX(-50%);
    font-family: "Inter", sans-serif;
    font-size: 0.75rem;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: var(--muted);
    mix-blend-mode: difference;
  }

  .close-button {
    position: fixed;
    top: 2rem;
    right: 2rem;
    background: none;
    border: none;
    color: var(--ink);
    font-size: 2rem;
    cursor: pointer;
    mix-blend-mode: difference;
    font-family: "Inter", sans-serif;
    font-weight: 300;
    transition: opacity 300ms;
  }

  .close-button:hover {
    opacity: 0.7;
  }
</style>

<script>
  let {
    isOpen = $bindable(false),
    currentIndex = $bindable(0),
    items = [],
  } = $props();

  let visible = $state(false);

  function swipe(node) {
    let startX = 0;

    function handleTouchStart(e) {
      startX = e.touches[0].clientX;
    }

    function handleTouchEnd(e) {
      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;
      const threshold = 50;

      if (Math.abs(diff) > threshold) {
        if (diff > 0) next();
        else prev();
      }
    }

    node.addEventListener("touchstart", handleTouchStart);
    node.addEventListener("touchend", handleTouchEnd);

    return {
      destroy() {
        node.removeEventListener("touchstart", handleTouchStart);
        node.removeEventListener("touchend", handleTouchEnd);
      },
    };
  }

  function close() {
    visible = false;
    setTimeout(() => (isOpen = false), 700);
  }

  function next() {
    currentIndex = (currentIndex + 1) % items.length;
  }

  function prev() {
    currentIndex = currentIndex === 0 ? items.length - 1 : currentIndex - 1;
  }

  function handleKeydown(e) {
    if (!isOpen) return;

    if (e.key === "Escape") close();
    else if (e.key === "ArrowRight") next();
    else if (e.key === "ArrowLeft") prev();
  }

  function handleBackdropClick(e) {
    if (e.target === e.currentTarget) close();
  }

  $effect(() => {
    if (isOpen) {
      visible = true;
    } else {
      visible = false;
    }
  });

  $effect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("keydown", handleKeydown);
      return () => window.removeEventListener("keydown", handleKeydown);
    }
  });
</script>

{#if isOpen}
  <div
    class="lightbox-overlay"
    class:visible
    onclick={handleBackdropClick}
    use:swipe
  >
    <div class="lightbox-content">
      {#if items[currentIndex]?.type === "image"}
        {#key currentIndex}
          <img
            src="./medium_images/{items[currentIndex].filename}"
            srcset="./medium_images/{items[currentIndex]
              .filename} 1200w, ./original_images/{items[currentIndex]
              .filename} 3000w"
            sizes="90vw"
            alt={items[currentIndex].alt || ""}
          />
        {/key}
      {:else if items[currentIndex]?.type === "video"}
        <video
          src={items[currentIndex].src}
          poster={items[currentIndex].poster}
          controls
          autoplay
        ></video>
      {/if}
    </div>

    <button class="nav-button prev" onclick={prev}>‹</button>
    <button class="nav-button next" onclick={next}>›</button>

    <div class="counter">
      {String(currentIndex + 1).padStart(2, "0")} / {String(
        items.length,
      ).padStart(2, "0")}
    </div>

    <button class="close-button" onclick={close}>×</button>
  </div>
{/if}
